import React, { FC } from 'react'
import styled from 'styled-components'
import { Icon } from 'ui/icon'
import { EcomIconsId } from 'ui/icon/types'

import { getProjectName } from '../../lib/get-project-name'

type SizeVariants = 'xs' | 'small' | 'normal' | 'large'

const sizeVariantToIconsSize = {
  xs: 0.5,
  small: 0.75,
  normal: 1,
  large: 1.25,
  subnormal: 0.85
}

export type Props = {
  text?: string
  icon?: EcomIconsId
  size?: SizeVariants
  direction?: 'row' | 'column'
  type?: 'primary' | 'secondary'
  textSize?: SizeVariants
  iconSize?: SizeVariants | 'subnormal' // 🤔 на деталке иконки размером 0.85, не ложится ни в какую логику, но что поделать
}

export const LabeledIcon: FC<Props> = ({
  text,
  icon,
  size = 'normal',
  textSize = size,
  iconSize = size,
  direction = 'column',
  type = 'primary',
  children,
  ...rest
}) => {
  let color = ''
  if (getProjectName() === 'avito') {
    color = 'black'
  } else if (getProjectName() === 'generic_v2') {
    color = '#828282'
  }

  return (
    <Inner>
      {icon && <Icon name={icon} size={sizeVariantToIconsSize[iconSize]} color={color} />}
      <Text size={textSize} type={type} {...rest}>
        {text && text}
        {!text && children}
      </Text>
    </Inner>
  )
}

const Inner = styled.div<{ direction?: Props['direction'] }>`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.grey[500]};
`

const Text = styled.div<{ size?: Props['size']; type: Props['type'] }>`
  font-weight: ${() => {
    return getProjectName() === 'ora' ? '400 !important' : ''
  }};
  color: ${({ theme, type }) => {
    if (getProjectName() === 'tank') return theme.palette.grey[500]
    if (getProjectName() === 'generic_v2') return theme.palette.grey[600]
    return type === 'primary' ? theme.palette.black : theme.palette.grey[500]
  }};
  padding-left: 0.4em;
  ${({ theme, size }) => {
    if (size === 'small') return theme.textStyles.p3
    if (size === 'large') return theme.textStyles.p1
    if (size === 'xs') return 'font-size: 10px !important'
    return theme.textStyles.p2
  }};
  font-size: ${({ theme, type }) => {
    if (getProjectName() === 'generic_v2') return '14px'
    return '16px'
  }};
  line-height: ${() => {
    return getProjectName() === 'haval' ? '1.4rem' : 'normal'
  }};
`
